/* Genuine links and native details/forms work without JavaScript. */
if (!customElements.get('artema-eich-header')) {
 customElements.define('artema-eich-header', class extends HTMLElement {
  connectedCallback() {
   if (this._controller) return;
   this._controller = new AbortController();
   const options = {signal:this._controller.signal};
   const init = () => {
    if (this._initialized || !this.isConnected) return;
    this._navigation=this.querySelector('[data-aeh-navigation]');
    if (!this._navigation) return;
    this._initialized=true;
    this._menus=[...this.querySelectorAll('[data-aeh-menu]')];
    this._desktop=matchMedia('(min-width:901px)');
    this.classList.add('is-ready');
    const sync = () => {this.closeMenus();this._navigation.open=this._desktop.matches;};
    /* Preserve the parser-time state and any interaction before deferred initialization. */
    if (this._navigation.dataset.bootstrapped !== 'true') sync();
    this._desktop.addEventListener('change',sync,options);
    this._menus.forEach(menu=>{
     menu.addEventListener('toggle',()=>{if(menu.open)this._menus.forEach(other=>{if(other!==menu&&other.open)other.open=false;});},options);
     menu.addEventListener('pointerenter',event=>{
      if(!this._desktop.matches||event.pointerType!=='mouse'||!matchMedia('(hover:hover)').matches)return;
      clearTimeout(this._timer);this._timer=setTimeout(()=>{this.closeMenus();menu.open=true;},180);
     },options);
     menu.addEventListener('pointerleave',()=>{clearTimeout(this._timer);},options);
    });
    this.addEventListener('pointerleave',()=>{clearTimeout(this._timer);if(this._desktop.matches)this._timer=setTimeout(()=>{if(!this.contains(document.activeElement))this.closeMenus();},260);},options);
    this.addEventListener('pointerenter',()=>clearTimeout(this._timer),options);
    this.addEventListener('keydown',event=>{
     if(event.key==='Escape'){
      clearTimeout(this._timer);
      const open=this._menus.find(menu=>menu.open);
      if(open){open.open=false;open.querySelector('summary').focus();event.preventDefault();}
      else if(!this._desktop.matches&&this._navigation.open){this._navigation.open=false;this._navigation.querySelector('summary').focus();event.preventDefault();}
     }
    },options);
    document.addEventListener('pointerdown',event=>{
     if(this.contains(event.target))return;
     clearTimeout(this._timer);this.closeMenus();
     if(!this._desktop.matches)this._navigation.open=false;
     this.querySelector('[data-aeh-locale]')?.removeAttribute('open');
    },options);
    document.addEventListener('focusin',event=>{
     if(!this.contains(event.target)){clearTimeout(this._timer);this.closeMenus();if(!this._desktop.matches)this._navigation.open=false;}
    },options);
    this.addEventListener('click',event=>{
     const link=event.target.closest?.('a');
     if(link&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey){clearTimeout(this._timer);this.closeMenus();if(!this._desktop.matches)this._navigation.open=false;}
    },options);
    this._observer=new ResizeObserver(()=>document.documentElement.style.setProperty('--header-height',Math.round(this.getBoundingClientRect().height)+'px'));
    this._observer.observe(this);
   };
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{...options,once:true});else init();
  }
  closeMenus(){this._menus?.forEach(menu=>{if(menu.open)menu.open=false;});}
  disconnectedCallback(){clearTimeout(this._timer);this._observer?.disconnect();this._controller?.abort();this._controller=null;this._initialized=false;}
 });
}
